/*
 * keyHandling: misc functions related to keyup, keydown, keypress
 */

var keyHandling = {
  /* 
   * Returns true if keyCode is a non-printable key, false otherwise.
   * options.includeEnter will count the enter key as non printable when true.
   */
  keyIsNonPrintable: function(keyCode, options) {
    var nonPrintableKeyCodes = [
      9, // tab
      27, // esc
      16, // shift
      17, // control
      18, // alt
      20, // caps lock
      144, // num lock
      37, // left arrow
      38, // up arrow
      39, // down arrow
      40, // right arrow
      45, // insert
      36, // home
      35, // end
      33, // page up
      34, // page down
      112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123 // f keys
    ];

    if (options != null && options.includeEnter == true)
      nonPrintableKeyCodes.push(13); // enter

    return nonPrintableKeyCodes.indexOf(keyCode) != -1;
  }
};